import React from "react";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, MEDIUM_RECTANGLE_AD_FIELDS } from "./definitions";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";
import InputTextSection from "./InputTextSection";
import InputSwitchSection from "./InputSwitchSection";

const CREATIVE_TYPE = CREATIVE_NAMES.MEDIUM_RECTANGLE_SKYBOX

export default function MediumRectangleSkybox({
    videoCreativeUrl,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    vastUrl,
    vastDuration,
    videoCreativeType,
    adServingType,
    enableMrssFeed,
    mrssFeed,
    midRollCuepoint
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <InputSwitchSection
                    label="Use MRSS Feed?"
                    creativeType={CREATIVE_TYPE}
                    isChecked={!!enableMrssFeed}
                    switchName={MEDIUM_RECTANGLE_AD_FIELDS.enableMrssFeed}
                    changeHandler={handleChange}
                >
                    <InputTextSection
                        adtype={CREATIVE_TYPE}
                        changeHandler={handleChange}
                        label="MRSS Feed URL"
                        textInput={true}
                        name={MEDIUM_RECTANGLE_AD_FIELDS.mrssFeed}
                        value={mrssFeed}
                    />
                    <InputTextSection
                        adtype={CREATIVE_TYPE}
                        changeHandler={handleChange}
                        label="Midroll ad break/cue point"
                        min={10}
                        name={MEDIUM_RECTANGLE_AD_FIELDS.midRollCuepoint}
                        value={midRollCuepoint}
                        isNumericInput={true}
                    />
                </InputSwitchSection>
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={MEDIUM_RECTANGLE_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={MEDIUM_RECTANGLE_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastUrl={vastUrl}
                    vastInputName={MEDIUM_RECTANGLE_AD_FIELDS.vastUrl}
                    vastDurationInputName={MEDIUM_RECTANGLE_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
            </BaseCreativeControls>

        </>
    );
}